import { Controller } from '@hotwired/stimulus'

// Botão que navega: troca o texto por "Abrindo…" sem bloquear o link e
// restaura se a pessoa voltar (bfcache / cache do Turbo).
export default class extends Controller {
  connect() {
    this.restaura = () => this.element.querySelectorAll('[data-carregando-original]').forEach((el) => {
      el.textContent = el.dataset.carregandoOriginal
      el.removeAttribute('aria-disabled')
      delete el.dataset.carregandoOriginal
    })
    window.addEventListener('pageshow', this.restaura)
    document.addEventListener('turbo:before-cache', this.restaura)
  }

  disconnect() {
    window.removeEventListener('pageshow', this.restaura)
    document.removeEventListener('turbo:before-cache', this.restaura)
  }

  marcar(event) {
    const el = event.currentTarget
    if (!el.dataset.carregandoOriginal) el.dataset.carregandoOriginal = el.textContent
    el.setAttribute('aria-disabled', 'true')
    el.textContent = event.params.texto || 'Abrindo…'
  }
}
